import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Fragment } from "react";

const COLS = [
  {
    title: "Services",
    links: [
      { label: "Live Chat Support", href: "/#services" },
      { label: "Virtual Assistant", href: "/#services" },
      { label: "Customer Service", href: "/#services" },
      { label: "Lead Generation", href: "/#services" },
      { label: "Admin Support", href: "/#services" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "Why NovaWorks", href: "/#why" },
      { label: "Results", href: "/#metrics" },
      { label: "Clients", href: "/#testimonials" },
      { label: "Get a Quote", href: "/#contact" },
    ],
  },
];

const LEGAL = [
  { label: "Terms & Conditions", to: "/terms" },
  { label: "Privacy Policy", to: "/privacy" },
  { label: "Refund & Cancellation Policy", to: "/refund" },
];

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#0A0A0A] text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-16 md:pt-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-16">
          <div className="md:col-span-6">
            <div className="inline-flex bg-white px-4 py-3 border border-white/15">
              <img
                src="/novaworks-logo.png"
                alt="NovaWorks Global Solutions"
                className="h-9 w-auto"
              />
            </div>
            <p className="mt-5 text-white/55 leading-relaxed max-w-sm">
              Fully-managed business process outsourcing. Live chat, virtual
              assistants, customer service, lead generation and admin support.
            </p>
            <a
              href="/#contact"
              data-testid="footer-cta"
              className="mt-7 inline-flex items-center gap-2 bg-white text-[#0A0A0A] px-6 py-3 text-xs font-bold uppercase tracking-[0.15em] hover:bg-[#002DFF] hover:text-white transition-colors"
            >
              Start a Conversation <ArrowUpRight className="w-4 h-4" />
            </a>
          </div>

          {COLS.map((c) => (
            <div key={c.title} className="md:col-span-3">
              <div className="text-xs font-bold uppercase tracking-[0.2em] text-white/40">{c.title}</div>
              <ul className="mt-5 space-y-3">
                {c.links.map((l) => (
                  <li key={l.label}>
                    <a href={l.href} className="text-sm text-white/70 hover:text-white transition-colors">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar: legal links + copyright */}
        <div className="border-t border-white/15 py-10 flex flex-col items-center gap-6 text-center">
          <nav
            data-testid="footer-legal-links"
            className="flex flex-wrap items-center justify-center gap-x-4 gap-y-3 text-xs font-bold uppercase tracking-[0.18em]"
          >
            {LEGAL.map((l, i) => (
              <Fragment key={l.to}>
                {i > 0 && <span className="hidden sm:inline text-white/25" aria-hidden="true">|</span>}
                <Link
                  to={l.to}
                  data-testid={`footer-legal-${l.to.slice(1)}`}
                  className="text-white/70 hover:text-[#002DFF] transition-colors"
                >
                  {l.label}
                </Link>
              </Fragment>
            ))}
          </nav>

          <div className="space-y-1">
            <p className="text-xs uppercase tracking-[0.15em] text-white/40">
              © {new Date().getFullYear()} NovaWorks Global Solutions. All Rights Reserved.
            </p>
            <p className="text-xs uppercase tracking-[0.15em] text-white/30">
              Knoxville, TN · Davao City, PH · General Santos, PH
            </p>
          </div>
        </div>
      </div>

      <div className="overflow-hidden border-t border-white/15">
        <div className="font-display font-black uppercase tracking-tighter text-[18vw] leading-[0.8] text-white/[0.06] text-center select-none whitespace-nowrap">
          NOVAWORKS
        </div>
      </div>
    </footer>
  );
};
